module.exports = __webpack_public_path__ + "static/media/alicloud.ede2c0f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alicloud.svg
// module id = 1316
// module chunks = 49